<template>
  <div class="bodyTable">
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-data-table
        v-if="datiPopolati"
        v-model="selected"
        color="blue lighten-4"
        item-key="codiceRiga"
        :headers="headers"
        :items="righeDocumento"
        :item-class="itemBackground"
        :options.sync="options"
        :server-items-length="totaleRighe"
        :loading="loading"
        class="elevation-1"
        @click:row="clickRow"
        @dblclick:row="dblclickRow"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, 100]
        }"
        dense
        calculate-widths
        :single-expand="singleExpand"
        :expanded.sync="expanded"
      > 
<!--       @item-expanded="test"
      show-expand -->
      <!-- item-key="codiceRiga" -->
      <!-- :show-expand="locRigaDocumento && locRigaDocumento.usaScalaTaglie" -->
        <template v-slot:[`item.rigaDescrittiva`]="{ item, index }">
          <component :is="'pSwitch'" :item="itemRigaDescrittiva(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="disableRigaDescrittiva(item)" :updateTrigger="updateTrigger"/>
        </template>      
        <template v-slot:[`item.codice`]="{ item, index }">
          <component :is="'pProdotto'" v-if="!rigaEsistente[index] && !item.rigaDescrittiva"
            :item="itemCodice(item)" :index="index" :appoggio="item.appoggio"
            :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"
            :refreshSource="refreshSource" :refreshSourceCode="refreshSourceCode"
            :forzaAggiornamento="forzaAggiornamento" :abilitaRicercaInterna="abilitaRicercaInterna"
            @change="componentValueChange" />
          <v-text-field v-else-if="!item.rigaDescrittiva" dense hide-details="auto" solo flat :value="itemCodice(item, true)" @click="re(index)"/>
        </template>       
        <template v-slot:[`item.descrizione`]="{ item, index }">
          {{ (item.rigaIndentata ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '') }}<component :is="'pTesto'" :item="itemDescrizione(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>
        <template v-slot:[`item.quantita`]="{ item, index }">
          <component :is="'pTesto'" :item="itemQuantita(item)" :ref="`quantita_${index}`" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly || item.usaScalaTaglie" :updateTrigger="updateTrigger" :suTable="true" :backColor="getColoreQuantita(item)"/>
        </template>
        <template v-slot:[`item.unitaMisura`]="{ item, index }">
          <component :is="'pMultiselect'" v-if="!rigaEsistente[index]" :item="itemUnitaMisura(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
          <v-text-field v-else dense hide-details="auto" solo flat :value="itemUnitaMisura(item, true)" @click="re(index)"/>
        </template>
        <template v-slot:[`item.listino`]="{ item, index }">
          <component :is="'pMultiselect'" v-if="!rigaEsistente[index]" :item="itemListino(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
          <v-text-field v-else dense hide-details="auto" solo flat :value="itemListino(item, true)" @click="re(index)"/>
        </template>
        <template v-slot:[`item.aliquota`]="{ item, index }">
          <component :is="'pMultiselect'" v-if="!rigaEsistente[index]" :item="itemAliquota(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
          <v-text-field v-else dense hide-details="auto" solo flat :value="itemAliquota(item, true)" @click="re(index)"/>
        </template>
        <template v-slot:[`item.valore.prezzoMinimo`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getPrezzoMinimoEuro(item)" background-color="transparent"/>
        </template>        
        <template v-slot:[`item.valore.prezzoTotale`]="{ item, index }">
          <v-text-field v-if="mostraPrezzoReadOnly(item)" dense solo flat hide-details="auto" readonly :value="getPrezzoTotale(item) | euro" background-color="transparent"/>
          <component :is="'pTesto'" v-if="mostraPrezzoEditabile(item)"  :textClass="'text-align-center'" :item="itemPrezzoTotale(item)" :ref="`ordine_prezzo_${index}`" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        </template>        
        <template v-slot:[`item.valore.prezzoNettoTotale`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getSconto(item)| euro" background-color="transparent"/>
        </template>
        <template v-slot:[`item.valore.importoTotale`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getImportoTotale(item) | euro" :background-color="getColoreImporto(item)"/>
        </template>
  <!--       <template v-slot:[`item.valore.importoNettoTotale`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getImponibile(item)" background-color="transparent"/>
        </template>
        <template v-slot:[`item.valore.prezzoNettoUnitario`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getIva(item) | euro" background-color="transparent"/>
        </template>  -->
        <template v-slot:[`item.giacenza`]="{ item }">
          <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getGiacenza(item)" background-color="transparent"/>
        </template>
        <template v-slot:[`item.omaggio`]="{ item, index }">
          <component v-if="!item.rigaDescrittiva" :is="'pSwitch'" :item="itemOmaggio(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/>
        </template>   
        <template v-slot:[`item.actions`]="{ item, index }">
          <v-icon small :disabled="readOnly" @click="deleteItem(item)" title="Cancella la riga">mdi-delete</v-icon>
          <v-icon v-if="!item.rigaDescrittiva" :disabled="readOnly" small class="ml-3" @click="onCalculator(item)" title="Modifica prezzi e sconti">mdi-calculator</v-icon>
          <v-dialog v-model="dialog" max-width="500px"  :retain-focus="false">
            <v-card>
              <v-card-title>
                <span class="text-h5">Sconti e importi</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <component :is="'pQuattroValori'" :item="itemPrezzi(itemCalc)" :index="indexCalc(itemCalc)" :appoggio="itemAppoggio(itemCalc)" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :lockValori="aggiornaSconti ? 1 : 2" @toggleLock="toggleLock"/>
                    </v-col>
                    <v-col cols="12">
                      <component :is="'pQuattroValori'" :item="itemSconti(itemCalc)" :index="indexCalc(itemCalc)" :appoggio="itemAppoggio(itemCalc)" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :lockValori="!aggiornaSconti ? 1 : 2" @toggleLock="toggleLock"/>
                    </v-col>
                    <v-col cols="12">
                      <component :is="'pQuattroValori'" :item="itemImporti(itemCalc)" :index="indexCalc(itemCalc)" :appoggio="itemAppoggio(itemCalc)" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click.stop="dialogClose">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-menu :offset-x="true" left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-3" :disabled="readOnly" v-bind="attrs" v-on="on" title="Azioni aggiuntive">mdi-dots-vertical</v-icon>
            </template>
            <three-dots-menu :item="item" :index="index" :rowsNumber="righeDocumento.length" @click="menuClick"/>
          </v-menu>    
        </template>
<!--         <template v-slot:[`foot`]>
            <v-btn class="text-right" :disabled="readOnly" @click="onNuovaRiga" v-if="nuovaRigaAbilitata">Nuova riga</v-btn>
        </template> -->
        <template v-slot:[`body.append`]>
            <td :colspan="4">
              <v-btn class="text-right mr-5 mt-2 mb-2" :disabled="readOnly" @click="onNuovaRiga" v-if="nuovaRigaAbilitata">Nuova riga</v-btn>
              <v-btn class="text-right  mt-2 mb-2" :disabled="readOnly" @click="onNuovaRigaST" v-if="nuovaRigaAbilitata && nuovaRigaAbilitataST" color="blue-grey lighten-4">Nuova riga Scala Taglie</v-btn>
            </td>
        </template>        
        <template v-slot:[`footer.prepend`]>
          <v-btn color="success" :disabled="readOnly" @click="onMostraParcheggio" v-if="nuovaRigaAbilitata">Importa da Park</v-btn>
          <v-btn color="blue-grey" class="white--text ml-5" @click="onUsaQrLotti" v-if="nuovaRigaAbilitata && usaImportLettureQr">
            Inserisci QR Lotti
            <!-- <v-icon v-if="presenzaDocumenti" right dark color="yellow" title="Sezione compilata - Presenza informazioni">mdi-text-box-edit-outline</v-icon> -->
          </v-btn>          
          <h3 v-if="!nuovaRigaAbilitata" class="red--text">E' necessario selezionare un cliente per poter aggiungere i prodotti</h3>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="articoliSelected">
            <dettaglio-scala tipoInput="quantita" :coloreSuRighe="coloreSuRighe" :codiceProdotto="item.codice" :scalaTaglie="item.scalaTaglie" :mostraValoreUnico="true" :refresh="triggerRefresh" @change="salvaDatiST(item, $event)"></dettaglio-scala>
          </td>
        </template>
        <template v-slot:[`item.expand`]="{ item }">
          <v-btn icon @click="expanded = [item]" v-if="item.usaScalaTaglie && !expanded.includes(item)"><v-icon>mdi-chevron-down</v-icon></v-btn>
          <v-btn icon @click="expanded = []" v-if="item.usaScalaTaglie && expanded.includes(item)"><v-icon>mdi-chevron-up</v-icon></v-btn>
        </template>        
<!--         <template v-slot:data-table-expand="{ item, isExpanded, expand }">
          <v-btn @click="expand(true)" v-if="item.usaScalaTaglie && !isExpanded">Expand</v-btn>
          <v-btn @click="expand(false)" v-if="item.usaScalaTaglie && isExpanded">close</v-btn>
        </template> -->
      </v-data-table>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
          <v-card-text>{{dettaglioRiga}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
            <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <dialog-storico :show="dialogStorico" :cliente="cliente()" :prodotto="prodottoStorico" @aggiornaPrezzo="aggiornaPrezzo"/>
      <import-qr-lotti :show="dialogQrLotti" :item="locDocumento"  @dialog-close="dialogQrLotti=false" @carica-prodotti="onCaricaProdotti"></import-qr-lotti>
    </v-form>
  </div>
</template>

<script>
/* eslint-disable */
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import { v4 as uuidv4 } from 'uuid'
  import prodotti from '@/services/prodottiService.js'
  import magazzino from '@/services/magazzinoService.js'  
  import configurazioni from '@/services/configurazioniService.js'
  import pProdotto from './elementi/prodotto'
  import pSwitch from './elementi/switch'
  import pTesto from './elementi/testo'
  import pMultiselect from './elementi/multiselect'
  import pQuattroValori from './elementi/quattroValori'
  import ThreeDotsMenu from './elementiBody/threeDotsMenu'
  import DialogStorico from './elementiBody/dialogStorico'
  import DettaglioScala from '@/views/custom/scalaTaglie/elementi/dettaglioScala'
  import ImportQrLotti from './importQrLotti'

  export default {
    components: {
      pProdotto,
      pSwitch,
      pTesto,
      pMultiselect,
      pQuattroValori,
      ThreeDotsMenu,
      DialogStorico,
      DettaglioScala,
      ImportQrLotti
    },
    props: {
      locDocumento: Object,
      trigger: { type: Number, default: 1 },
      readOnly: { type: Boolean, default: false }
    },
    data () {
      return {
        selected: [],
        loading: false,
        options: {},
        headersDefault: [
          // https://dev.to/andynoir/draggable-table-row-with-vuejs-vuetify-and-sortablejs-1o7l
          /* { text: '', value: 'updown', sortable: false , width: '10px'}, */
          { text: 'Descrittiva', value:'rigaDescrittiva', width: '1%' }, 
          { text: 'Codice', value: 'codice', align: 'start', width: '10%'},
          { text: 'Descrizione', value: 'descrizione', width: '20%' },
          { text: 'Quantità', value: 'quantita', align: 'start', width: '5%' },
          { text: 'UM', value: 'unitaMisura', align: 'start', width: '5%' },
          { text: 'Listino', value: 'listino', align: 'start', width: '8%' },
          { text: 'Aliquota', value: 'aliquota' , align: 'start', width: '8%'},
        /*        
          { text: 'Prezzi', value: 'prezzi' , align: 'start'},
          { text: 'Sconti', value: 'sconti' , align: 'start'},
          { text: 'Importi', value: 'importi' , align: 'start'},
        */
          { text: 'Minimo', value: 'valore.prezzoMinimo', align: 'start'},
          { text: 'Importo Unitario', value: 'valore.prezzoTotale', align: 'start'},
          { text: 'Sconto', value: 'valore.prezzoNettoTotale', align: 'start'},
          { text: 'Importo Totale', value: 'valore.importoTotale', align: 'start'},
/*           { text: 'Imponibile', value: 'valore.importoNettoTotale', align: 'start'},
          { text: 'Iva', value: 'valore.prezzoNettoUnitario', align: 'start'}, */
          { text: 'Giac.', value: 'giacenza', align: 'start'},
          { text: 'Omaggio', value: 'omaggio', align: 'start'},
          { text: 'Actions', value: 'actions', sortable: false, width: '80px'}
        ],
        headersScalaTaglie: [
          { text: '', value: 'expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialog: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
/*         defaultItem: null,
        modelloDocumento: null, */
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreDocumento: '',
        updateTrigger: 1,
        refreshSource: 1,
        refreshSourceCode: '',
        forzaAggiornamento: false,
        // readOnly: false, // eventualmente su computed,
        locRigaDocumento: null,
        rigaModello: {
          rigaDescrittiva: false,
          codice: '',
          descrizione: '',
          quantita: '',
          unitaMisura: '',
          listino: null,
          aliquota: null,
          prezzi: null,
          sconti: null,
          importi: null
        },
        aggiornaSconti: true, // da impostazioni scelgo se aggiornare gli sconti o il prezzo di listino nel caso di modifica dell'importo,
        dialogStorico: false,
        prodottoStorico: null,
        prodottoIndex: null,
        mostraCalcolati: true,
        mostraParcheggio: false,
        listinoMinimo: '',
        itemCalc: null,
        formFieldsValid: true,
        rigaEsistente: {},
        datiPopolati: false,
        abilitaRicercaInterna: false, // TODO: Prendere da impostazioni/backoffice/prodotti/abilitaRicercaInterna,
        numDecimali: 4,
        nuovaRigaAbilitataST: false,
        coloreSuRighe: true,
        triggerRefresh: 1,
        usaImportLettureQr: false,
        dialogQrLotti: false
      }
    },
    computed: {
      righeDocumento() {
        return _.get(this, 'locDocumento.righe', [])
      },
      totaleRighe() {
        return this.righeDocumento.length
      },
      nuovaRigaAbilitata() {
        return this.trigger && this.locDocumento.anagrafica
      },
      dettaglioRiga() {
        let riga = this.editedIndex
        if (riga === -1) return
        let ed = this.righeDocumento[riga]
        if (!ed) return ''
        return ed.descrizione.trim()
      },
      headers() {
        const hd = this.nuovaRigaAbilitataST ? this.headersDefault.concat(this.headersScalaTaglie) : this.headersDefault
        return hd
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      dialog (val) {
        val || this.dialogClose()
      },     
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },
    async mounted () {
      this.$root.$on('aggiungiProdotti', this.onAggiungiProdotti)
      const listini = await configurazioni.getConfigurazione('listini', 'listini')
      const lMin = listini.find(x => x.minimo)
      if (lMin) {
        this.listinoMinimo = lMin.codice
      }
      this.rigaEsistente = Array(this.righeDocumento.length).fill(false)
      this.datiPopolati = true
      
      // Usato per popolare i totali su ordini da Web. TODO: Il calcolo dei totali deve essere fatto al momento della generazione dell'ordine e non sulla riapertura --> moleculer
      if (this.righeDocumento.length > 0 && !this.locDocumento.totali) {
        this.aggiornaValori('xxx')
        this.updateTrigger++
        this.$emit('updateTotali')
      }
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.nuovaRigaAbilitataST = !!impostazioni.usaScalaTaglie
      this.usaImportLettureQr = !!impostazioni.usaImportLettureQr
    },
    methods: {
      onUsaQrLotti() {
        this.dialogQrLotti = !this.dialogQrLotti
      },
      re(index) {
        this.rigaEsistente[index] = false
        this.updateTrigger++
      },
      datiCompleti() {
        const valid = this.$refs.form.validate()
        return valid // TODO: Completare verifica
      },
      onCalculator(item) {
        this.dialog = true
        this.itemCalc = item
      },
      indexCalc(item) {
        if (!item) return -1
        const idx = this.locDocumento.righe.indexOf(item)
        return idx
      },
      itemAppoggio(item) {
        return item && item.appoggio
      },
      itemBackground(item) {
        return item.omaggio ? 'is-omaggio' : ''
      },
      async onCaricaProdotti(elenco) {
        this.dialogQrLotti = false
        await this.onAggiungiProdotti(elenco)
      },      
      async onAggiungiProdotti(righe) {
        for (let riga of righe) {
          const idProdotto = riga.codice
          const p = await prodotti.getProdotto(idProdotto)
          let nr = JSON.parse(JSON.stringify(this.rigaModello))
          nr.valore = nr.valore || {}
          nr.valore.listino = this.locDocumento.appoggio.clifor.amministrativi.listino
          nr.valore = { ...nr.valore, ...this.locDocumento.appoggio.clifor.amministrativi.sconti }
          _.set(nr, 'appoggio.prodotto', p)
          _.set(nr, 'prodotto.codice', idProdotto)
          if (riga.note) {
            nr.note = riga.note
          }
          this.$emit('nuovaRiga', nr) // verificare se a questo livello o alla fine, dopo aver aggiunto il prodotto
          await this.$nextTick()
          const index = this.locDocumento.righe.length - 1
          let data = {
            model: 'prodotto.codice',
            subModel: null,
            value: p._id,
            item: p,
            index: index
          }
          await this.componentValueChange(data)
          data = {
            model: 'quantita',
            decimals: 2,
            subModel: null,
            value: riga.quantita,
            item: null,
            index: index
          }
          await this.componentValueChange(data)
        }
        await this.$nextTick()
        this.mostraParcheggio = false
        this.$emit('mostraParcheggio', false)
      },
      onMostraParcheggio() {
        this.mostraParcheggio = !this.mostraParcheggio
        this.$emit('mostraParcheggio', this.mostraParcheggio)
      },
      cliente() {
        return _.get(this.locDocumento, 'anagrafica.cliente', null)
      },
      async menuClick({ command, index }) {
        switch(command) {
          case 'utility_storico':
            this.dialogStorico = true
            this.prodottoStorico = this.locDocumento.righe[index]
            this.prodottoIndex = index
            await this.$nextTick()
            this.dialogStorico = false
            break
          case 'utility_calcolati':
            this.mostraCalcolati = !this.mostraCalcolati
            break
          case 'move_top':
            this.$emit('move', index, 0)
            break
          case 'move_bottom':
            this.$emit('move', index, -1)
            break
          case 'move_up':
            this.$emit('move', index, index - 1)
            break
          case 'move_down':
            this.$emit('move', index, index + 1)
            break
          default:
            break
        }
      },
      disableRigaDescrittiva(item) {
        const isProdotto = item.prodotto && item.prodotto.codice.length > 0 ? true : false
        const isQuantita = item.quantita && parseFloat(item.quantita) > 0 ? true : false
        return this.readOnly || isProdotto || isQuantita
      },
      toggleLock() {
        this.aggiornaSconti = !this.aggiornaSconti
      },
      dialogClose () {
        this.dialog = false
        this.$nextTick(() => {
/*           this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1 */
        })
      },
      getPrezzoMinimoEuro(item) {
        const listinoMinimo = this.listinoMinimo
        const prezzoMinimo = listinoMinimo ? _.get(item, `appoggio.prodotto.item.prezzo.${listinoMinimo}.base`, 0) : ''
        if (prezzoMinimo) {
          return `${this.$options.filters.euro(prezzoMinimo)}`
        }
        const acq = _.get(item, 'appoggio.prodotto.acquisto', '')
        return acq ? `(${this.$options.filters.euro(acq)})` : ''
      },
      getPrezzoTotale(item) {
        if (!item || !item.valore || !item.valore.listino) return '0'
        // return item.valore.listino.ivato ? item.valore.prezzoTotale : item.valore.prezzoNettoTotale
        const valore = (item.valore.listino.ivato ? item.valore.importoUnitario : item.valore.importoNettoUnitario) || 0
        return valore
      },
      mostraPrezzoReadOnly(item) {
        // const isProdotto = item.appoggio && item.appoggio.prodotto && item.appoggio.prodotto.item && item.appoggio.prodotto.item.tipoItem === 'PRODOTTO'
        const isProdotto = _.get(item, 'appoggio.prodotto.item.tipoItem') === 'PRODOTTO' || _.get(item, 'appoggio.prodotto.tipoItem') === 'PRODOTTO'
        return !item.rigaDescrittiva && isProdotto
      },
      mostraPrezzoEditabile(item) {
        // const isReparto = item.appoggio && item.appoggio.prodotto && item.appoggio.prodotto.item.tipoItem === 'REPARTO'
        const isReparto = _.get(item, 'appoggio.prodotto.item.tipoItem') === 'REPARTO' || _.get(item, 'appoggio.prodotto.tipoItem') === 'REPARTO'
        return !item.rigaDescrittiva && isReparto
      },
      getImportoTotale(item) {
        if (!item || !item.valore || !item.valore.listino) return '0'
        const value = item.valore.listino.ivato ? item.valore.importoTotale || '0' : item.valore.importoNettoTotale || '0'
        return value
      },      
      getSconto(item) {
        if (!item || !item.valore || !item.valore.listino) return '0'
        if (item.valore.listino.ivato) {
          return  +(parseFloat(item.valore.prezzoTotale) - parseFloat(item.valore.importoTotale)).toFixed(2)
        } else {
          return  +(parseFloat(item.valore.prezzoNettoTotale) - parseFloat(item.valore.importoNettoTotale)).toFixed(2)
        }
      },
      getImponibile(item) {
        // In base alla normativa, il valore su cui calcolare l'iva per l'omaggio è il prezzo di acquisto 
        const valoreCalcoloIvaSuOmaggio = '0.00 €' // item.appoggio.prodotto.acquisto
        return item.omaggio ? `(${valoreCalcoloIvaSuOmaggio})` : this.$options.filters.euro(item.valore.importoNettoTotale)
      },
      getIva(item) {
        return +(parseFloat(item.valore.importoTotale) - parseFloat(item.valore.importoNettoTotale)).toFixed(2)
      },
      getGiacenza(item) {
        const magazzinoGiacenza = _.get(this.locDocumento, 'tipoDocumento.magazzinoGiacenza', 'totale')

        if (magazzinoGiacenza === 'totale') {
          return this.updateTrigger && _.get(item, 'appoggio.prodotto.item.magazzino.giacenza', 0)
        }

        const magazzino = magazzinoGiacenza === 'principale' ? _.get(this.locDocumento, 'magazzino', 'mag01') : _.get(this.locDocumento, 'magazzino2', 'mag01')

        let valore = _.get(item, `appoggio.prodotto.item.magazzino.giacenzaParziale['${magazzino}'].giacenza`, null)
        if (valore === null) {
          valore = _.get(item, 'appoggio.prodotto.item.magazzino.giacenza', 0)
        }
        return this.updateTrigger && valore
        // return this.updateTrigger && _.get(item, 'appoggio.prodotto.item.magazzino.giacenza', 0)
      },
      getColoreQuantita(item) {
        const giacenza = this.getGiacenza(item)
        if (!item.quantita) {
          return 'transparent'
        }
        const qta = parseFloat(item.quantita)
        return qta > giacenza ? 'red' : qta === giacenza ? 'orange lighten-2' : 'transparent'
      },
      getColoreImporto(item) {
        // Su impostazioni il nome del listino da considerare come prezzo minimo
        const listinoMinimo = this.listinoMinimo
        if (!listinoMinimo) {
          return 'transparent'
        }
        const prezzoMinimo = _.get(item, `appoggio.prodotto.item.prezzo.${listinoMinimo}.base`, 0)
        const prz = parseFloat(item.valore.importoTotale)
        return prz < prezzoMinimo ? 'red' : prz === prezzoMinimo ? 'orange lighten-2' : 'transparent'
      },
      itemRigaDescrittiva(item) {
        return  {
          "model": "rigaDescrittiva",
          "valueField": "rigaDescrittiva",
          "type": "Switch",
          "label": "",
          value: _.get(item, 'rigaDescrittiva', false)
        }
      },
      itemCodice(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'prodotto.codice', '')
        }
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          "cercaEsterno": true,
          "usaScalaTaglie": _.get(item, 'usaScalaTaglie', ''),
          value: _.get(item, 'prodotto.codice', '')  
        }
      },
      itemDescrizione(item) {
        return {
          "model": "descrizione",
          "valueField": "descrizione",
          "label": "Descrizione",
          "type": "TextArea",
          "required": true,
          value: _.get(item, 'descrizione', '') 
        }
      },
      itemQuantita(item) {
        return {
          "model": "quantita",
          "valueField": "quantita",
          "label": "Quantità",
          "type": "Testo",
          "required": !_.get(item, 'appoggio.rigaDescrittiva', false) && !item.usaScalaTaglie,
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'quantita', '') 
        }
      },
      itemPrezzoTotale(item, onlyValue) {
        let valore = 0
        let model = 'valore.importoUnitario'
        if (item.valore && item.valore.listino && item.valore.listino.ivato) {
          valore = item.valore.importoUnitario
        }
        if (item.valore && item.valore.listino && !item.valore.listino.ivato) {
          valore = item.valore.importoNettoUnitario
          model = 'valore.importoNettoUnitario'
        }
        if (onlyValue) {
          return valore
        }
        return {
          "model": model,
          "valueField": model,
          "label": "Importo unitario",
          "type": "Testo",
          "required": !_.get(item, 'appoggio.rigaDescrittiva', false),
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: valore
        }
      },      
      itemUnitaMisura(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'unitaMisura', '') 
        }        
        return {
          "model": "unitaMisura",
          "subModel": "codice",
          "valueField": "unitaMisura",
          "type": "Multiselect",
          "label": "UM",
          "source": "prodotti_unita_misura.um",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: this.updateTrigger && _.get(item, 'unitaMisura', '') 
        }
      },
      itemListino(item, onlyValue) {
        if (onlyValue) {
          return  _.get(item, 'valore.listino.descrizione', '') 
        }            
        return {
          "model": "valore.listino",
          "valueField": "valore.listino",
          "type": "Multiselect",
          "label": "Listino",
          "source": "listini.listini",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'valore.listino', '') 
        }
      },
      itemAliquota(item, onlyValue) {
        if (onlyValue) {
          return  _.get(item, 'aliquotaIva.descrizione', '') 
        }   
        return {
          "model": "appoggio.aliquotaIva",
          "valueField": "appoggio.aliquotaIva",
          "type": "Multiselect",
          "label": "Aliquota Iva",
          "source": "prodotti_aliquote_iva.aliquote",
          "required": false,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'aliquotaIva', '') 
        }
      },
      itemPrezzi(item) {
        return {
          "label": "Prezzi",
          "model1": "valore.prezzoNettoUnitario",
          "valueField1": "valore.prezzoNettoUnitario",
          "label1": "netto unitario",
          "classTestCondition1": "appoggio.listino.nonIvato",
          "classIfCondition1": "font-weight-black",
          "model2": "valore.prezzoNettoTotale",
          "valueField2": "valore.prezzoNettoTotale",
          "label2": "netto totale",
          "classTestCondition2": "appoggio.listino.nonIvato",
          "classIfCondition2": "font-weight-black",
          "model3": "valore.prezzoUnitario",
          "valueField3": "valore.prezzoUnitario",
          "label3": "unitario",
          "classTestCondition3": "appoggio.listino.ivato",
          "classIfCondition3": "font-weight-black",
          "model4": "valore.prezzoTotale",
          "valueField4": "valore.prezzoTotale",
          "label4": "totale",
          "classTestCondition4": "appoggio.listino.ivato",
          "classIfCondition4": "font-weight-black",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.prezzoNettoUnitario', ''),
          value2: _.get(item, 'valore.prezzoNettoTotale', ''),
          value3: _.get(item, 'valore.prezzoUnitario', ''),
          value4: _.get(item, 'valore.prezzoTotale', '')
        }
      },
      itemSconti(item) {
        return {
          "label": "Sconti",
          "model1": "valore.sconto1",
          "valueField1": "valore.sconto1",
          "label1": "sconto 1",
          "model2": "valore.sconto2",
          "valueField2": "valore.sconto2",
          "label2": "sconto 2",
          "model3": "valore.sconto3",
          "valueField3": "valore.sconto3",
          "label3": "sconto 3",
          "model4": "valore.sconto4",
          "valueField4": "valore.sconto4",
          "label4": "sconto 4",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.sconto1', ''),
          value2: _.get(item, 'valore.sconto2', ''),
          value3: _.get(item, 'valore.sconto3', ''),
          value4: _.get(item, 'valore.sconto4', '')      
        }
      },
      itemImporti(item) {
        return       {
          "label": "Importi",
          "model1": "valore.importoNettoUnitario",
          "valueField1": "valore.importoNettoUnitario",
          "label1": "netto unitario",
          "model2": "valore.importoNettoTotale",
          "valueField2": "valore.importoNettoTotale",
          "label2": "netto totale",
          "model3": "valore.importoUnitario",
          "valueField3": "valore.importoUnitario",
          "label3": "unitario",
          "model4": "valore.importoTotale",
          "valueField4": "valore.importoTotale",
          "label4": "totale",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.importoNettoUnitario', ''),
          value2: _.get(item, 'valore.importoNettoTotale', ''),
          value3: _.get(item, 'valore.importoUnitario', ''),
          value4: _.get(item, 'valore.importoTotale', '')
        }
      },
      itemOmaggio(item) {
        return  {
          "model": "omaggio",
          "valueField": "omaggio",
          "type": "Switch",
          "label": "",
          value: _.get(item, 'omaggio', false)
        }
      },
      rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      },
      async onNuovaRiga() {
        const nr = JSON.parse(JSON.stringify(this.rigaModello))
        nr.valore = nr.valore || {}
        nr.valore.listino = this.locDocumento.appoggio.clifor.amministrativi.listino
        nr.valore = { ...nr.valore, ...this.locDocumento.appoggio.clifor.amministrativi.sconti }
        this.$emit('nuovaRiga', nr)
      },
      async onNuovaRigaST() {
        const nr = JSON.parse(JSON.stringify(this.rigaModello))
        nr.valore = nr.valore || {}
        nr.valore.listino = this.locDocumento.appoggio.clifor.amministrativi.listino
        nr.valore = { ...nr.valore, ...this.locDocumento.appoggio.clifor.amministrativi.sconti }
        nr.usaScalaTaglie = true
        this.$emit('nuovaRiga', nr)
      },
      async editItem (item) {
/*         this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.completaAppoggio()
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      duplicateItem(item) {
/*         this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      deleteItem (item) {
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.dialogDelete = true
/*         this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true */
      },
      async deleteItemConfirm () {
        // TODO: Verificare se necessario cancellare il movimento
        const riga = this.righeDocumento[this.editedIndex]
        const documento = this.locDocumento
        await magazzino.cancellaRigaPerRiferimento('documento', documento.codice, documento.data, riga.codice)   

        this.righeDocumento.splice(this.editedIndex, 1)
        this.forzaAggiornamento = true

        this.closeDelete()
        this.editedIndex = -1
        this.$emit('updateTotali')
        await this.$nextTick()
        this.forzaAggiornamento = false
        this.$emit('salvaDocumento')
      },

      close () {
        this.dialog = false
/*         this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        }) */
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          // this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      async save () {
/*         this.$store.commit('documentiDettaglio/CLEAR_RIGA_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['documentiDettaglio/rigaDocumento']
        let documento = await documenti.getDocumento(this.chiaveDocumento._id)
        if (this.editedIndex > -1) {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          Object.assign(this.righeDocumento[this.editedIndex], this.editedItem)
          Object.assign(documento.righe[this.editedIndex], this.editedItem)
        } else {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          this.righeDocumento.push(this.editedItem)
          documento.righe = documento.righe || []
          documento.righe.push(this.editedItem)
        }
        if (!await documenti.aggiornaDocumento(documento)) {
          this.dialogErrore = true
          return
        }
        this.close()
        this.$store.commit('documentiDettaglio/CLEAR_RIGA_DOCUMENTO')
        await this.getDataFromApi() */
      },      
      erroreConfirm() {
        this.dialogErrore = false
        this.erroreDocumento = ''
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
/*         const item = options.item
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
/*       datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        }) 
        return elaborati
      },
      deleteDatiVisualizzazione(documento) {
        let locDocumento = {...documento}
        delete locDocumento.c_nominativo
        delete locDocumento.appoggio
        return locDocumento
      }, */
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      aggiornaPrezzo({ listino, valore, codice }) {
        this.forzaAggiornamento = false
        this.refreshSourceCode = codice
        this.refreshSource++
      },
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        this.locRigaDocumento = this.righeDocumento[index]
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.locRigaDocumento, tgt)
        await this.aggiornaCorrelati(data)
        // this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.locRigaDocumento) // verificare se va fatta store_temp
      },
      async aggiornaCorrelati(data) {
        this.locRigaDocumento.appoggio = this.locRigaDocumento.appoggio || {}
        let tipoModifica = ''
        switch (data.model) {
          case 'prodotto.codice':
            if (!data.value) {
              delete this.locRigaDocumento.appoggio.prodotto
              delete this.locRigaDocumento.prodotto
              _.set(this.locRigaDocumento, 'valore.prezzoUnitario', 0)   
              this.locRigaDocumento.descrizione = ''
            } else {
              if (!this.locRigaDocumento.codiceRiga) {
                this.locRigaDocumento.codiceRiga = uuidv4()
                if (this.locRigaDocumento.usaScalaTaglie) {
                  this.locRigaDocumento.scalaTaglie = _.get(data.item, 'item.custom.scalaTaglie')
                  console.log(this.locRigaDocumento)
                  this.expanded = [this.locRigaDocumento]
                }
              }
              this.locRigaDocumento.appoggio.prodotto = data.item
              if (this.locRigaDocumento.usaScalaTaglie) {
                this.locRigaDocumento.descrizione = data.item.descrizione
              } else {
                this.locRigaDocumento.descrizione = `${data.item.descrizione} ${_.get(data.item, 'variante2.descrizione', '')} ${_.get(data.item, 'variante1.descrizione', '')}`
              }
              if (this.locRigaDocumento.appoggio.importiModificati) { // La prima volta, devo rileggere il prodotto ma non impostare il listino. Se cambio prodotto, si
                this.locRigaDocumento.appoggio.importiModificati = false
                this.updateTrigger++
                return
              }
              this.locRigaDocumento.tipoBene = data.item.tipoBene || data.item.item.tipoBene
              this.locRigaDocumento.repartoFiscale = data.item.datiFiscali.reparto.stampante

              let um = _.get(this, 'locRigaDocumento.unitaMisura', '') || _.get(data.item, 'magazzino.unitaMisura', '') || _.get(data.item, 'item.magazzino.unitaMisura', '') || _.get(data.item, 'item.magazzino.um', '')
              this.locRigaDocumento.unitaMisura = um
              this.locRigaDocumento.aliquotaIva = _.get(this, 'locRigaDocumento.aliquotaIva', null) || data.item.datiFiscali.aliquoteIva[0]
              await this.$nextTick()

              const ref = this.$refs[`quantita_${data.index}`]
              const input = ref.$el.querySelector('input:not([type=hidden]),textarea:not([type=hidden])')
              if (input) {
                setTimeout(() => {
                  input.focus()
                }, 0)
              }
            }
            break;
          case 'rigaDescrittiva':
            delete this.locRigaDocumento.appoggio.prodotto
            delete this.locRigaDocumento.prodotto
            _.set(this.locRigaDocumento, 'valore.prezzoUnitario', 0)
            _.set(this.locRigaDocumento, 'appoggio.rigaDescrittiva', data.value)       
            this.locRigaDocumento.descrizione = ''
            break;
          case 'valore.listino':
            _.set(this.locRigaDocumento,'appoggio.listino.ivato', _.get(data,'value.ivato', true))
            _.set(this.locRigaDocumento,'appoggio.listino.nonIvato', !_.get(data,'value.ivato', true))
            tipoModifica = data.model
            break;
          case 'valore.sconto1':
          case 'valore.sconto2':
          case 'valore.sconto3':
          case 'valore.sconto4':
            this.locRigaDocumento.sconti = this.rigaSconti(this.locRigaDocumento.valore)
            tipoModifica = data.model
            break;
          case 'valore.prezzoUnitario':          
          case 'valore.prezzoTotale':
          case 'valore.prezzoNettoUnitario':
          case 'valore.prezzoNettoTotale':
          case 'valore.importoUnitario':
          case 'valore.importoTotale':
          case 'valore.importoNettoUnitario':
          case 'valore.importoNettoTotale':
            tipoModifica = data.model
            this.locRigaDocumento.valore.importiModificati = true // viene messo su appoggio alla successiva riapertura della riga
            break;        
          case 'appoggio.aliquotaIva':
            this.locRigaDocumento.aliquotaIva = this.locRigaDocumento.appoggio.aliquotaIva
            this.locRigaDocumento.aliquotaIva.valore = this.locRigaDocumento.aliquotaIva.aliquota
            this.locRigaDocumento.repartoFiscale = _.get(this.locRigaDocumento, 'appoggio.aliquotaIva.stampante.posizione')
            console.log('repartoFiscale', this.locRigaDocumento.repartoFiscale)
            tipoModifica = data.model
            break;
          case 'quantita':
            tipoModifica = data.model       
            break;
          default:
            break
        }
        this.aggiornaValori(tipoModifica)
        this.updateTrigger++
        this.$emit('updateTotali')
      },
/*       rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      }, */
      round2Dec(value) {
        const fattore = Math.pow(10, this.numDecimali)
        return Math.round( value * fattore + Number.EPSILON ) / fattore
      },      
      aggiornaValori(tipoModifica) {
        const rd = _.get(this.locRigaDocumento,'appoggio.rigaDescrittiva', false)
        const prd = _.get(this.locRigaDocumento,'appoggio.prodotto', {})
        const lst = _.get(this.locRigaDocumento,'valore.listino.codice', '')
        const ivato = rd ? true : _.get(this.locRigaDocumento,'valore.listino.ivato', true) // Verificare come gestire se riga descrittiva
        const lc = `_L_${this.locDocumento.anagrafica.cliente.codice}` // Listino specifico per cliente
        let pl = rd ? parseFloat(_.get(this.locRigaDocumento,'valore.prezzoUnitario', 0)) : parseFloat(_.get(prd, `prezzoItem.${lc}.base`, 0)) || parseFloat(_.get(prd, `prezzoItem.${lst}.base`, 0)) || parseFloat((ivato ? _.get(this.locRigaDocumento, `valore.importoUnitario`, 0) : _.get(this.locRigaDocumento, `valore.importoNettoUnitario`, 0)))
        const qta = parseFloat(_.get(this.locRigaDocumento,'quantita', 0))
        let sc1 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto1', 0) || '0')
        let sc2 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto2', 0) || '0')
        let sc3 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto3', 0) || '0')
        let sc4 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto4', 0) || '0')
        let sconto = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
        // const iva = _.get(prd,'datiFiscali.aliquoteIva[0]', {})
/*    
        const iva = _.get(this.locRigaDocumento,'aliquotaIva.valore', {})
        if (!this.locRigaDocumento.aliquotaIva) { // Modifico solo se non ho l'aliquota forzata dal cliente
          this.locRigaDocumento.aliquotaIva = iva
        } */
        const aliquota = rd ? '' : (this.locRigaDocumento.aliquotaIva && (this.locRigaDocumento.aliquotaIva.valore || this.locRigaDocumento.aliquotaIva.aliquota)) || 0
        let aggiornaSconti = this.aggiornaSconti
        if (parseFloat(this.locRigaDocumento.valore.prezzoUnitario || 0) === 0) {
          // Se prezzo di listino nullo (es reparto o prezzi non inseriti) --> aggiornaSconti = false !!
          aggiornaSconti = false
        }
        if (ivato) {
          switch (tipoModifica) {
            case 'valore.prezzoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
              break;
            case 'valore.prezzoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoTotale) / qta
              break;
            case 'valore.prezzoNettoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) * ( 1 + aliquota / 100)
              break;
            case 'valore.prezzoNettoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoTotale) * ( 1 + aliquota / 100) / qta
              break;
            case 'valore.importoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoUnitario) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / sconto
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / sconto
              }
              break;
            case 'valore.importoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario || 0)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoTotale) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
              }
              break;
            case 'valore.importoNettoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
              }
              break;
            case 'valore.importoNettoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
              } else {
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
              }
              break; 
            case 'valore.sconto1':
            case 'valore.sconto2':
            case 'valore.sconto3':
            case 'valore.sconto4':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) || pl
              break;
            default:
              // pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) || pl
              break;
          }
          if (tipoModifica) {
            this.locRigaDocumento.valore.prezzoUnitario = pl ? this.round2Dec(pl) : 0
            this.locRigaDocumento.valore.prezzoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? this.round2Dec(pl / ( 1 + aliquota / 100)): 0
            this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoUnitario = pl ? +this.locRigaDocumento.valore.prezzoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? +this.locRigaDocumento.valore.prezzoNettoUnitario.toFixed(this.numDecimali) : 0

            this.locRigaDocumento.valore.importoUnitario = pl ? this.round2Dec(pl * sconto) : 0
            this.locRigaDocumento.valore.importoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? this.round2Dec((pl / ( 1 + aliquota / 100)) * sconto) : 0
            this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoNettoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoUnitario = pl ? +this.locRigaDocumento.valore.importoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? +this.locRigaDocumento.valore.importoNettoUnitario.toFixed(this.numDecimali) : 0
          } else {
            console.log('tipo modifica nullo')
          }
        } else {
        switch (tipoModifica) {
            case 'valore.prezzoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) / ( 1 + aliquota / 100)
              break;
            case 'valore.prezzoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoTotale) / ( 1 + aliquota / 100) / qta
              break;
            case 'valore.prezzoNettoUnitario':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
              break;
            case 'valore.prezzoNettoTotale':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoTotale) / qta
              break;
            case 'valore.importoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.prezzoUnitario) / sconto
                pl = parseFloat(this.locRigaDocumento.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
              }
              break;
            case 'valore.importoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / (sconto * qta)
                pl = parseFloat(this.locRigaDocumento.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
              }
              break;
            case 'valore.importoNettoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / sconto
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoUnitario) / sconto
              }
              break;
            case 'valore.importoNettoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (sconto * qta)
              } else {
                // pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
                pl = parseFloat(this.locRigaDocumento.valore.importoNettoTotale) / (sconto * qta)
              }
              break;
            case 'valore.sconto1':
            case 'valore.sconto2':
            case 'valore.sconto3':
            case 'valore.sconto4':
              pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) || pl
              break;
            default:
              // pl = parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario) || pl
              break;
          }        

          if (tipoModifica) {
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? this.round2Dec(pl) : 0
            this.locRigaDocumento.valore.prezzoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoNettoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoUnitario = pl ? this.round2Dec(pl * ( 1 + aliquota / 100)) : 0
            this.locRigaDocumento.valore.prezzoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.prezzoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoNettoUnitario = pl ? +this.locRigaDocumento.valore.prezzoNettoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.prezzoUnitario = pl ? +this.locRigaDocumento.valore.prezzoUnitario.toFixed(this.numDecimali) : 0
            
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? this.round2Dec(pl * sconto) : 0
            this.locRigaDocumento.valore.importoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoNettoUnitario)).toFixed(this.numDecimali) : 0
            
            this.locRigaDocumento.valore.importoUnitario = pl ? this.round2Dec((pl * ( 1 + aliquota / 100)) * sconto) : 0
            this.locRigaDocumento.valore.importoTotale = qta && pl ? +(qta * parseFloat(this.locRigaDocumento.valore.importoUnitario)).toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoNettoUnitario = pl ? +this.locRigaDocumento.valore.importoNettoUnitario.toFixed(this.numDecimali) : 0
            this.locRigaDocumento.valore.importoUnitario = pl ? +this.locRigaDocumento.valore.importoUnitario.toFixed(this.numDecimali) : 0
          } else {
            console.log('tipo modifica nullo')
          }          
        }
        console.log("pl", pl)
      },
      rielaboraSconti(oldSc, sconto) {
        let sc1 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto1', 0) || '0')
        let sc2 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto2', 0) || '0')
        let sc3 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto3', 0) || '0')
        let sc4 = parseFloat(_.get(this.locRigaDocumento,'valore.sconto4', 0) || '0')

        let newSc = 1
        if (sconto < oldSc) {
          sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
          _.set(this.locRigaDocumento,'valore.sconto4', sc4.toFixed(this.numDecimali))
        } else {
          if (sc4) {
            sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
            if (sc4 < 0) sc4 = 0
              _.set(this.locRigaDocumento,'valore.sconto4', sc4.toFixed(this.numDecimali))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
          if (newSc < sconto && sc3) {
            sc3 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc4 / 100))) * 100
            if (sc3 < 0) sc3 = 0
              _.set(this.locRigaDocumento,'valore.sconto3', sc3.toFixed(this.numDecimali))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
          if (newSc < sconto && sc2) {
            sc2 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
            if (sc2 < 0) sc2 = 0
              _.set(this.locRigaDocumento,'valore.sconto2', sc2.toFixed(this.numDecimali))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)                
          if (newSc < sconto && sc1) {
            sc1 = (1 - sconto / ((1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
            // if (sc1 < 0) sc1 = 0 // Non cancello, se minore di zero è una Maggiorazione
              _.set(this.locRigaDocumento,'valore.sconto1', sc1.toFixed(this.numDecimali))
          }
        }
      },
      async salvaDatiST(item, payload) {
        let qtaTotale = 0
        let przTotale = 0
        let elencoProdotti = []
        for (let c of payload.scala.colori) {
          let valori = payload.valori[c.codice]
          for (let t of payload.scala.taglie) {
            if (!valori[String(t.codice)]) {
              continue
            }
            const valore = +parseFloat(valori[t.codice] || 0).toFixed(2)
            qtaTotale += valore
            const id = prodotti.creaCampoRicercaTC_Codici(item.prodotto.codice, t.codice, c.codice)
            let prodotto = await prodotti.getProdotto(id)
            const listino = _.get(item, 'valore.listino.codice', 'L1')
            let prezzoUn = _.get(prodotto, 'prezzo.' + listino + '.base', 0)
            // let accisa = _.get(prodotto, 'prezzo.' + listino + '.accisa', 0)
            // prezzoUn += accisa
            const pzTot = prezzoUn * valore
            przTotale += pzTot
            elencoProdotti.push({
              id: id,
              //taglia: t.codice,
              taglia: t,
              // tagliaDescrizione: t.descrizione,
              // colore: c.codice,
              colore: c,
              // coloreDescrizione: c.descrizione,
              quantita: valore,
              prezzo: pzTot
            })
/*             let prodotto = await prodotti.getProdotto(id)
            if (!prodotto) {
              continue
            } */
          }
        }
        item.scalaTaglie.elencoProdotti = elencoProdotti
        item.quantita = qtaTotale
        item.valore.prezzoTotale = przTotale
        item.valore.prezzoUnitario = +(przTotale / qtaTotale).toFixed(2)
        this.aggiornaValori('valore.prezzoUnitario')
        this.updateTrigger++
        this.$emit('updateTotali')        
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.articoliSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }

  .bodyTable .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0;
  }

  .is-omaggio {
    background-color: #DCEDC8;
  }
</style>
